const DiamondIcon = ({ className, style }) => {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 24 24"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <path d="M12 2L2 8.5L12 22L22 8.5L12 2ZM12 5.5L17.5 9L12 17L6.5 9L12 5.5Z" />
    </svg>
  )
}

export default DiamondIcon
